import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export const validateGovernmentIdService = async (
    governmentId: string | undefined,
    apiKey: string,
    apiProxyPath: string,
    authenticationData?: AuthenticationData,
): Promise<boolean> => {
    const response = await apiClient<{ status: string }>(`${apiProxyPath}/validation/government_id`, {
        method: 'POST',
        body: { governmentId },
        apiKey,
        authenticationData,
        sentryTag: 'validate_government_id',
    });
    return response.status === 'VALID';
};
